var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"portal-indicator"},_vm._l((_vm.portals),function(portal){return _c('span',{style:({'background-color': _vm.all[portal]})})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }